/* eslint-disable prettier/prettier */
/* eslint-disable react/prop-types */

import TextField from "@mui/material/TextField";
import Grid from "@mui/material/Grid";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import { useState, useEffect } from "react";
import toast from "react-hot-toast";
import { Divider, Typography, Icon } from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import InputFileUpload from "./InputFile";
import InputFileDownloadClinica from "./inputDowloadClinica";
import { Button, Tooltip, ButtonGroup, Box } from "@mui/material";
import { FileUploader } from "react-drag-drop-files";
import { PropaneSharp } from "@mui/icons-material";
import { descargarDocumetacionGeneral } from "store/download/dowloadActions";
import { useDispatch, useSelector } from "react-redux";
import DescargarArchivo from "../DescargaArchivos";
import _ from "lodash";
import ModalConfirmacion from "./confirmacion";
import { udateLaadingDescargaArchivo } from "store/solicitudes/solicitudesSlice";
import {
  ActualizarEstadoDocumento,
  UpdateEstadoDocumentacionSolicitud,
  AddArchivoSolicitudClinica,
  DelArchivoSolicitud,
  ActualizarObservacionesSolicitud,
} from "store/solicitudes/solicitudesActions";
import GrupoBotonesEstatus from "./buttonGroupStatus";
import ModalContent from "../../../components/ModalContent";
import ModalAgregarEstudio from "./agregarDocumentos";
import { store } from "store/store";

function DocumentacionClinicaEdit({
  documentacionClinica,
  estatusdocumentacion,
  idSolicitud,
  observacionesAudiologo,
  observacionesOtorrino,
  esExpediente,
  children,
}) {
  const dispatch = useDispatch();
  const [openModalAdd, setopenModalAdd] = useState(false);
  const [state, setState] = useState({});
  const [campoLoading, setcampoLoading] = useState("");
  const [textInfo, setTextInfo] = useState(observacionesOtorrino ? observacionesOtorrino : "");
  const [textInfo1, setTextInfo1] = useState(observacionesAudiologo ? observacionesAudiologo : "");
  const [valorestatus, setvalorestatus] = useState(0);
  const [isvalid_textInfo, isvalid_setTextInfo] = useState(false);
  const [isvalid_textInfo1, isvalid_setTextInfo1] = useState(false);
  const [open, setOpen] = useState(false);
  const [openDelete, setOpenDelete] = useState(false);
  const [docDelete, setDocDelete] = useState(false);

  const handleConfirm = async () => {
    setOpen(false);
    const res = await dispatch(
      ActualizarEstadoDocumento(idSolicitud, "docClinicaValidada", valorestatus)
    );
  };

  const handleConfirmDelete = () => {
    dispatch(
      DelArchivoSolicitud(idSolicitud, {
        tabla: docDelete.tabla,
        campo: docDelete.campo,
        ruta: docDelete.ruta,
        id: docDelete.id,
      })
    );
    setOpenDelete(false);
  };

  const ValidaForm = () => {
    if (!textInfo) {
      toast.error("Ingresa el texto de observación para continuar");
      isvalid_setTextInfo(true);
      return false;
    } else {
      dispatch(ActualizarObservacionesSolicitud(idSolicitud, "observacionesOtorrino", textInfo));
    }
    if (!textInfo1) {
      toast.error("Ingresa el texto de observación para continuar");
      isvalid_setTextInfo1(true);
      return false;
    } else {
      dispatch(ActualizarObservacionesSolicitud(idSolicitud, "observacionesAudiologo", textInfo1));
    }
  };

  const { progress, loading } = useSelector((state) => state.download);

  const DouwloadArchivoGral = async (ruta, id) => {
    if (!loading) {
      dispatch(udateLaadingDescargaArchivo({ tabla: "clinica", id: id, valor: true }));
      await dispatch(descargarDocumetacionGeneral(ruta));
      dispatch(udateLaadingDescargaArchivo({ tabla: "clinica", id: id, valor: false }));
    } else {
      toast.error("Solo es posible descargar un archivo a la vez, por favor a espera!!!");
    }
  };

  const usuarioPermisos = store.getState().login?.usuario?.permisos;

  const cargardocumentos = _.filter(
    usuarioPermisos,
    (p) => p.idPermiso == (esExpediente ? 67 : 20)
  );
  const validarDocumento = _.filter(
    usuarioPermisos,
    (p) => p.idPermiso == (esExpediente ? 68 : 21)
  );
  const eliminarDocumento = _.filter(
    usuarioPermisos,
    (p) => p.idPermiso == (esExpediente ? 69 : 22)
  );
  const validarSeccion = _.filter(usuarioPermisos, (p) => p.idPermiso == (esExpediente ? 70 : 23));

  const guardarObservacionesOtorrino = _.filter(
    usuarioPermisos,
    (p) => p.idPermiso == (esExpediente ? 71 : 24)
  );
  const guardarObservacionesAudiologia = _.filter(
    usuarioPermisos,
    (p) => p.idPermiso == (esExpediente ? 72 : 25)
  );

  return (
    <>
      <Grid container spacing={2}>
        <Grid item xs={12} md={3} lg={3}>
          <MDBox textAlign="left">
            <MDTypography
              component="a"
              href="#"
              variant="caption"
              color="primary"
              fontWeight="medium"
            >
              Documentación clínica
            </MDTypography>
            {cargardocumentos.length == 0 ? null : (
              <Button
                variant="contained"
                startIcon={<AddIcon />}
                color="info"
                sx={{
                  backgroundColor: "#1a2035",
                  textTransform: "none",
                  "&:hover": {
                    backgroundColor: "#1a2035", // mismo color que normal
                    boxShadow: "none", // evita sombra al pasar el mouse
                  },
                  marginLeft: 3,
                }}
                onClick={() => setopenModalAdd(true)}
              >
                Agregar
              </Button>
            )}
          </MDBox>
        </Grid>
        <Grid item xs={12} md={9} lg={9}>
          <Grid container spacing={2}>
            <Grid item xs={12} md={12} lg={12}>
              <MDBox textAlign="right">
                <GrupoBotonesEstatus
                  estatus={estatusdocumentacion?.docClinicaValidada}
                  onSeleccion={(opcion) => {
                    if (validarSeccion.length > 0) {
                      setOpen(true);
                      setvalorestatus(opcion);
                    }
                  }}
                />
                <MDTypography
                  ml={2}
                  component="a"
                  href="#"
                  variant="caption"
                  color="primary"
                  fontWeight="medium"
                >
                  {estatusdocumentacion?.docClinicaValidada == 1
                    ? estatusdocumentacion?.docClinicaValidadaPor
                    : null}
                </MDTypography>
              </MDBox>
            </Grid>
          </Grid>
        </Grid>
      </Grid>

      <Divider />
      {children}

      {_.map(documentacionClinica, (item) => {
        return (
          <>
            <Grid container spacing={2}>
              <Grid item xs={12} md={3} lg={3}>
                <MDBox textAlign="right">
                  <MDTypography
                    variant="h5"
                    color={"white"}
                    style={{ opacity: 0.7, fontSize: "0.9rem" }}
                  >
                    {item.titulo}
                  </MDTypography>
                </MDBox>
              </Grid>
              <Grid item xs={12} md={9} lg={9}>
                <Grid container spacing={2}>
                  <Grid item xs={12} md={12} lg={12}>
                    <MDBox textAlign="left">
                      {item.rutaDescarga ? (
                        item?.loading ? (
                          <DescargarArchivo progress={progress} />
                        ) : (
                          <InputFileDownloadClinica
                            onClick={() => {
                              //setcampoLoading(item.campo);
                              DouwloadArchivoGral(item.rutaDescarga, item?.idDocumentacionClinica);
                            }}
                            estatus={item?.estado}
                            CambiarStatusDocumento={(nuevovalor) => {
                              dispatch(
                                UpdateEstadoDocumentacionSolicitud(
                                  idSolicitud,
                                  item?.idDocumentacionClinica,
                                  nuevovalor,
                                  "clinica"
                                )
                              );
                            }}
                            ocultarValidacionarchivo={validarDocumento.length == 0}
                            ocultarEliminacion={eliminarDocumento.length == 0}
                            EliminarDocumento={() => {
                              setDocDelete({
                                tabla: "documentacionclinica",
                                id: item?.idDocumentacionClinica,
                                campo: "",
                                ruta: item?.rutaDescarga,
                              });

                              setOpenDelete(true);
                            }}
                          />
                        )
                      ) : (
                        <></>
                      )}
                    </MDBox>
                  </Grid>
                </Grid>
              </Grid>
            </Grid>

            <Divider style={{ margin: 5 }} />
          </>
        );
      })}
      <Grid container spacing={2} mt={2}>
        <Grid item xs={12} md={3} lg={3}>
          <MDBox textAlign="right">
            <MDTypography variant="h5" color={"white"} style={{ opacity: 0.7, fontSize: "0.9rem" }}>
              Observaciones Otorrinolaringologia
            </MDTypography>
          </MDBox>
        </Grid>
        <Grid item xs={12} md={9} lg={9}>
          <Grid container spacing={2}>
            <Grid item xs={12} md={12} lg={12}>
              <MDBox textAlign="left">
                <TextField
                  value={textInfo}
                  onChange={(event) => {
                    setTextInfo(event.target.value);
                  }}
                  onFocus={() => {
                    isvalid_setTextInfo(false);
                  }}
                  label={"Ingrese observación"}
                  variant="outlined"
                  style={{ width: "100%", marginBottom: "1.5rem" }}
                  multiline
                  rows={5}
                  size="small"
                  autoComplete="off"
                  InputLabelProps={{ shrink: true }}
                  error={isvalid_textInfo}
                  helperText={
                    isvalid_textInfo ? "En necesario ingresar el texto para continuar" : ""
                  }
                  disabled={guardarObservacionesOtorrino.length == 0}
                />
              </MDBox>
            </Grid>
          </Grid>
        </Grid>
      </Grid>

      <Grid container spacing={2}>
        <Grid item xs={12} md={3} lg={3}>
          <MDBox textAlign="right">
            <MDTypography variant="h5" color={"white"} style={{ opacity: 0.7, fontSize: "0.9rem" }}>
              Observaciones Audiologia
            </MDTypography>
          </MDBox>
        </Grid>
        <Grid item xs={12} md={9} lg={9}>
          <Grid container spacing={2}>
            <Grid item xs={12} md={12} lg={12}>
              <MDBox textAlign="left">
                <TextField
                  value={textInfo1}
                  onChange={(event) => {
                    setTextInfo1(event.target.value);
                  }}
                  onFocus={() => {
                    isvalid_setTextInfo1(false);
                  }}
                  label={"Ingrese observación"}
                  variant="outlined"
                  style={{ width: "100%", marginBottom: "1.5rem" }}
                  multiline
                  rows={5}
                  size="small"
                  autoComplete="off"
                  InputLabelProps={{ shrink: true }}
                  error={isvalid_textInfo1}
                  helperText={
                    isvalid_textInfo1 ? "En necesario ingresar el texto para continuar" : ""
                  }
                  disabled={guardarObservacionesAudiologia.length == 0}
                />
              </MDBox>
            </Grid>
          </Grid>
        </Grid>
      </Grid>
      <Divider />

      <MDBox textAlign="right">
        {guardarObservacionesOtorrino.length > 0 || guardarObservacionesAudiologia.length > 0 ? (
          <Button
            variant="contained"
            onClick={() => ValidaForm()}
            sx={{ mt: 1, mr: 1 }}
            size="small"
            color="primary"
          >
            {"Guardar observaciones"}
          </Button>
        ) : null}
      </MDBox>

      <ModalConfirmacion
        open={open}
        onClose={() => setOpen(false)}
        onConfirm={handleConfirm}
        titulo="Comfirmación"
        mensaje="¿Estás seguro que deseas cambiar el estatus?"
      />

      <ModalConfirmacion
        open={openDelete}
        onClose={() => setOpenDelete(false)}
        onConfirm={handleConfirmDelete}
        titulo="Comfirmación"
        mensaje="¿Estás seguro que deseas eliminar este documento?"
      />

      <ModalAgregarEstudio
        open={openModalAdd}
        handleClose={() => setopenModalAdd(false)}
        onGuardar={(titulo, file) => {
          dispatch(
            AddArchivoSolicitudClinica(idSolicitud, {
              file: file,
              titulo: titulo,
            })
          );
        }}
      />
    </>
  );
}

export default DocumentacionClinicaEdit;
